import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import _, { isEmpty } from "lodash";
import actions from "./actions";
import ImageActions from "../images/actions";
import Form from "./components/Form";
import LoadingOverlay from "react-loading-overlay";
import Loader from "../common/components/Loader";
import Portal from "../common/components/Portal";
import InfoPage from "./components/Info";
import DataMain from "./components/DataMain";
import ConfirmationModal from "../common/components/ConfirmationModal";
import {
    addTableSliderDataToBreadcrumb,
    addToBreadCrumpData,
    checkPermission,
    findPrevPathFromBreadCrumpData,
    findPrevPathFromBreadCrumpRecData,
    getTableSliderData,
    popBreadCrumpOnPageClose,
    popBreadCrumpRecData,
    showAlert as showAlertUtil
} from "../../config/utils";
import history from "../../config/history";
import { assetTableData } from "./components/tableConfig";
import qs from "query-string";
import OnePagerModal from "./components/AssetOnePagerExportModal";
import { BulkUploadForm } from "./components/BulkUploadForm";
import { AppliedFilters } from "../common/AppliedFilters";
import {
    getCombinedAssetDashboardFilterTags,
    getAssetChartNavigationFilterCount,
    getAssetChartNavigationApiParams,
    getAssetDashboardAssetTableFilters,
    mergeAssetDashboardFiltersIntoParams,
    mergeAssetDashboardFiltersForDropdownApi,
    isMobileAssetDashboard
} from "../assetDashboard/utils";
import { MyFilters } from "./components/FilterModal/MyFilters";
import ExportModal from "./components/ExportModal";
import MultiSelectEditForm from "./components/MultiSelectEditForm";
import { permissions } from "../../config/permissions";
import { DynamicColumnModal } from "../common/DynamicColumnModal";
import { getTableConfig, saveTableConfig } from "../common/actions";
import { entities } from "../common/constants";
import { computeTableConfig, getPinnedColumnLeftPositions } from "../../utils/tableUtils";
import {
    resolveAssetViewFieldConfig,
    applyAssetViewVisibilityToTableConfig,
    splitAdminHiddenColumns,
    mergeAdminHiddenColumns,
    stripAdminHiddenColumnsFromSave
} from "./fieldVisibility/assetViewFieldConfigUtils";
import moment from "moment";
import AssetExportPopup from "./components/AssetExportPopup";
import AssetsOtto, { isLegacyStandaloneAssetsRoute } from "./AssetsOtto";
import { createTableController } from "../filterAssistant/capabilities/tableView/tableController";
import { canUseOtto } from "../filterAssistant/core/ottoAccess";
import "./asset.css";
import { isAssetDashboardCrumbName } from "../assetDashboard/constants";
class Assets extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.pinnedColumnsRef = {};
        let prevSectionId = this.props.assetReducer.entityParams.parentSectionId;
        const locationFrom = this.props.location?.state?.from;
        let isSameSession =
            prevSectionId === this.props.match.params.id &&
            locationFrom !== "charts" &&
            locationFrom !== "dashboard" &&
            locationFrom !== "assetDashboard" &&
            !this.props.isSmartChartView &&
            !this.props.isAssignView;

        const {
            match: {
                params: { section }
            }
        } = this.props;
        const isAssetDashboardNav = this.resolveAssetDashboardNavFlags();

        const persistedLocationState = isSameSession ? this.props.assetReducer.entityParams.locationState : {};
        const restoredLocationState = !isAssetDashboardNav && persistedLocationState?.from === "assetDashboard" ? {} : persistedLocationState;
        this.state = {
            isLoading: true,
            errorMessage: "",
            dataList: [],
            paginationParams: isSameSession
                ? this.props.assetReducer.entityParams.paginationParams
                : {
                      totalPages: 0,
                      perPage: 40,
                      currentPage: 0,
                      totalCount: 0
                  },
            showViewModal: false,
            showWildCardFilter: false,
            selectedRowId: isSameSession ? this.props.assetReducer.entityParams.selectedRowId : null,
            params:
                isSameSession || this.props.isSmartChartView
                    ? section && this.props.assetReducer.entityParams[section]
                        ? (this.props.assetReducer.entityParams[section]?.params ?? {
                              limit: 40,
                              offset: 0,
                              search: ""
                          })
                        : (this.props.assetReducer.entityParams.params ?? {
                              limit: 40,
                              offset: 0,
                              search: ""
                          })
                    : {
                          limit: 40,
                          offset: 0,
                          search: ""
                      },
            selectedData: this.props.match.params.id,
            tableData: {
                keys: assetTableData.keys,
                config:
                    isSameSession && !this.props.isSmartChartView
                        ? this.props.assetReducer.entityParams.tableConfig
                        : _.cloneDeep(assetTableData.config)
            },
            assetViewFieldConfig: null,
            alertMessage: "",
            wildCardFilterParams: isSameSession ? this.props.assetReducer.entityParams.wildCardFilterParams : {},
            filterParams: isSameSession ? this.props.assetReducer.entityParams.filterParams : {},
            historyPaginationParams: isSameSession
                ? this.props.assetReducer.entityParams.historyPaginationParams
                : {
                      totalPages: 0,
                      perPage: 40,
                      currentPage: 0,
                      totalCount: 0
                  },
            historyParams: isSameSession
                ? this.props.assetReducer.entityParams.historyParams
                : {
                      limit: 40,
                      offset: 0,
                      search: ""
                  },
            logData: {
                count: "",
                data: []
            },
            showConfirmModalLog: false,
            selectedLog: "",
            isRestoreOrDelete: "",
            tableLoading: false,
            infoTabsData: [],
            showForm: false,
            showInfoPage: false,
            isHistory: false,
            showConfirmModal: false,
            showHardDeleteConfirmationModal: false,
            showRestoreConfirmModal: false,
            imageResponse: [],
            customExcelExportLoading: false,
            summaryRowData: {
                crv_total: "",
                fca_cost_total: ""
            },
            locationState: this.props.location.state ? this.props.location.state : restoredLocationState,
            exportLoader: false,
            showOnePagerExportModal: false,
            selectedAssetData: {},
            parentSectionId: this.props.assetReducer.entityParams.parentSectionId,
            showFiltersPopup: false,
            showAppliedFilters: false,
            importType: "",
            showExportSettings: false,
            selectedAssetsId: isSameSession
                ? this.props.assetReducer.entityParams[section]?.selectedAssetsId || this.props.assetReducer.entityParams?.selectedAssetsId || []
                : [],
            showMultiSelectEditForm: false,
            initialFiltersSetForSmartChart: false,
            tableConfigChanged: false,
            tableDataExportFilters: isSameSession ? this.props.assetReducer.entityParams?.tableDataExportFilters || {} : {},
            setSearchField: "",
            setHighlightSearchField: "",
            showExportModal: false
        };
    }

    resolveAssetDashboardNavFlags = () => {
        const {
            location,
            match: {
                params: { section }
            }
        } = this.props;
        const bcData = findPrevPathFromBreadCrumpRecData();
        const isAssetDashboardNav = isAssetDashboardCrumbName(bcData?.[0]?.name) || location?.state?.from === "assetDashboard";
        this.isAssetDashboardFiltered =
            isAssetDashboardNav && ["assetinfo", "buildinginfo", "siteinfo", "regioninfo", "projectinfo"].includes(section);
        return isAssetDashboardNav;
    };

    componentDidMount = async () => {
        const {
            location: { search },
            match: {
                params: { id, tab }
            },
            isMobilecomAssetView = false
        } = this.props;
        const query = qs.parse(search);
        this.setState({ isTableResetting: true });
        if ((this.props.isProjectAssetView || isMobilecomAssetView) && this.props.clientId) {
            await this.props.getAssetDynamicFields({ client_id: query?.client_id ?? this.props.clientId ?? query?.c_id });
        } else {
            if (!this.props.isAssignAssetView || (this.props.isAssignAssetView && this.props.clientId)) {
                await this.props.getAssetDynamicFields({
                    client_id: this.props.clientId
                        ? this.props.clientId
                        : tab === "basicdetails"
                          ? query.client_id
                          : (query?.c_id ?? query.client_id ?? id)
                });
            }
        }
        this.handleScrollPosition();
        this.props.handleSelectAsset(null, false);
        if (!this.props.location.state || this.props.location?.state?.isInitialView || this.props.isAssignView) {
            // Keep chart/dashboard nav filters captured in the constructor if a later
            const existing = this.state.locationState;
            const hasChartNavFilters =
                existing &&
                typeof existing === "object" &&
                (existing.from === "assetDashboard" || existing.from === "charts") &&
                !existing.isInitialView;
            if (!hasChartNavFilters) {
                this.setState({ locationState: false });
            }
        }
        if (this.props.isSmartChartView && !this.props.isSurveyView) {
            if (!this.props.configParams || Object.keys(!this.props.configParams || {}))
                await this.resetAll(this.props.isSmartChartView ? false : true);
            let tempParams = { ...this.state.params };
            if (!this.props?.selectedRecomIdList.length) {
                tempParams = { ...tempParams, asset_ids: null };
            }
            if (this.props.configParams) {
                tempParams = { ...tempParams, ...this.props.configParams };
            }
            let tempSelectedAssetIds = [];
            tempSelectedAssetIds = (this.props?.selectedRecomIdList ?? []).map(assetId => {
                return {
                    id: assetId
                };
            });
            await this.setState({
                selectedAssetsId: tempSelectedAssetIds,
                params: tempParams,
                paginationParams: { ...this.state.paginationParams, perPage: this.props.configParams?.limit ?? this.state.paginationParams.perPage },
                tableDataExportFilters: this.props?.tableDataExportFilters,
                initialFiltersSetForSmartChart: true
            });
        }
        if (
            this.props.match.params.tab === "assets" ||
            (this.props.match.params.subTab === "assigned-assets" && this.props.clientId) ||
            this.props.isAssignView ||
            this.props.isSmartChartView ||
            this.props.match.params.tab === "mr-assets"
        ) {
            this.setState({ parentSectionId: this.props.match.params.id });
            if (this.props.clientId) {
                await this.setTableDataConfigBasedOnProject();
                this.setState({ isTableResetting: false });
            } else {
                this.setState({ isTableResetting: false });
            }
            if (this.state.parentSectionId && this.state.parentSectionId !== this.props.match.params.id) {
                this.resetAll();
            } else {
                await this.refreshDataList();
            }
        } else {
            this.setState({ isLoading: false, isTableResetting: false });
        }
    };

    componentDidUpdate = async (prevProps, prevState) => {
        const {
            location: { search },
            match: {
                params: { id, tab }
            },
            isMobilecomAssetView = false
        } = this.props;
        const query = qs.parse(search);
        if (prevProps.location?.key !== this.props.location?.key) {
            const isAssetDashboardNav = this.resolveAssetDashboardNavFlags();
            if (!isAssetDashboardNav && this.state.locationState?.from === "assetDashboard") {
                await new Promise(resolve => this.setState({ locationState: {} }, resolve));
                this.updateEntityParams();
                await this.refreshDataList();
            }
        }
        if (
            ((this.props.isProjectAssetView || this.props.isAssignAssetView || isMobilecomAssetView || this.props.hasOwnProperty("clientId")) &&
                (this.props.match.params.tab === "assets" || this.props.match.params.subTab === "assigned-assets") &&
                prevProps.clientId !== this.props.clientId) ||
            (isMobilecomAssetView && tab === "mr-assets" && prevProps.match?.params?.id !== id)
        ) {
            this.setState({ isTableResetting: true, isLoading: true, tableConfigChanged: false });
            await this.props.getAssetDynamicFields({ client_id: this.props.clientId ?? query?.c_id });
            await this.setTableDataConfigBasedOnProject();
            this.setState({ isTableResetting: false });
            await this.refreshDataList();
            // if (this.props.isAssignAssetView && this.props.clientId) await this.refreshDynamicFields();
        }
        if (prevProps.match.path !== this.props.match.path && this.props.match.path === "/assets") {
            this.handleScrollPosition();
        }
        const response = this.props?.assetReducer?.getDataByIdResponse;

        if (!this.state.infoTabsData.some(tab => tab.key === "weightedScore") && response?.id) {
            const assetFieldsObj = this.props.assetReducer?.assetDynamicFields?.asset_custom_field || {};
            const allFields = Object.values(assetFieldsObj ?? {})?.flat();
            const hasWeightedFields = (allFields ?? [])?.some(field => field?.field_mode === "weighted_selection");
            if (hasWeightedFields) {
                const newTab = {
                    key: "weightedScore",
                    name: "Assessment Table",
                    path: `/assets/assetInfo/${response?.id}/weightedScore?client_id=${response?.client?.id ?? response?.client?.id}`
                };

                const updatedTabs = [...this.state.infoTabsData];
                const assetTabIndex = updatedTabs?.findIndex(tab => tab?.key === "basicdetails");

                if (assetTabIndex !== -1) {
                    updatedTabs?.splice(assetTabIndex + 1, 0, newTab);
                } else {
                    updatedTabs?.push(newTab);
                }

                this.setState({ infoTabsData: updatedTabs });
            }
        }
        if (
            this.isAssetDashboardFiltered &&
            prevProps.assetDashboardReducer?.assetTableFilters !== this.props.assetDashboardReducer?.assetTableFilters
        ) {
            await this.refreshDataList();
        }
    };

    refreshDataList = async () => {
        this.setState({ isLoading: true });
        if (this.props.configParams) {
            await this.props.getAllAssetIds(this.props.configParams);
            const { recommendation_ids } = this.props.assetReducer.getWholeAssetIdsResponse;
            let tempSelected = [];
            recommendation_ids?.length &&
                recommendation_ids.forEach((id, index) => {
                    tempSelected.push({ id, index });
                });
            await this.setState({ selectedAssetsId: tempSelected });
        }
        const { params, paginationParams, tableData, locationState } = this.state;

        const {
            match: {
                params: { id, section }
            },
            location: { state }
        } = this.props;
        let dataList = [];
        let totalCount = 0;
        let crv_total = 0;
        let fca_cost_total = 0;
        const {
            location: { search },
            isMobilecomAssetView = false
        } = this.props;
        const query = qs.parse(search);
        let { subParams, clientIdToPersist } = this.getScopedAssetParams(params);
        if (clientIdToPersist) params.client_id = clientIdToPersist;
        if (this.shouldUseAssetChartDataApi(locationState)) {
            await this.props.getChartAssetDataList(this.buildAssetTableApiParams(subParams, locationState));
        } else {
            if (
                ((this.props.isProjectAssetView || isMobilecomAssetView) && this.props.clientId) ||
                (query?.is_mr && (query?.c_id || query?.client_id)) ||
                (!this.props.isProjectAssetView && !isMobilecomAssetView)
            ) {
                await this.props.getDataList(this.buildAssetTableApiParams(subParams, locationState));
            }
        }
        const { getDataResponse } = this.props.assetReducer || {};
        dataList = getDataResponse?.assets || [];
        totalCount = getDataResponse?.count || 0;
        crv_total = getDataResponse?.crv || 0;
        fca_cost_total = getDataResponse?.fca_cost_total || 0;
        // go to previous page is the last record of the current page is deleted
        if (dataList && !dataList.length && paginationParams.currentPage) {
            this.setState({
                params: {
                    ...params,
                    offset: (paginationParams.currentPage - 1) * paginationParams.perPage
                }
            });
            await this.props.getDataList(this.state.params);
            dataList = getDataResponse?.assets || [];
            totalCount = getDataResponse?.count || 0;
            crv_total = getDataResponse?.crv || 0;
            fca_cost_total = getDataResponse?.fca_cost_total || 0;
        }
        if (!dataList?.length && getDataResponse?.error) {
            this.setState({ alertMessage: getDataResponse.error }, () => this.showAlert());
        }

        this.updateEntityParams();
        if (
            ((this.props.isProjectAssetView || isMobilecomAssetView) && this.props.clientId) ||
            (!this.props.isProjectAssetView && !isMobilecomAssetView) ||
            (query?.is_mr && (query?.c_id || query?.client_id))
        ) {
            this.getListForCommonFilter({ field: "assets.has_recommendation" }, true);
            await this.setState({
                tableData: {
                    ...tableData,
                    data: dataList
                },
                dataList,
                summaryRowData: {
                    crv_total,
                    fca_cost_total
                },
                paginationParams: {
                    ...paginationParams,
                    totalCount: totalCount,
                    totalPages: Math.ceil(totalCount / paginationParams.perPage)
                },
                showWildCardFilter: this.state.params.filters ? true : false,
                isLoading: false
            });
        }
        if (
            this.props?.isSmartChartView &&
            ((this.props?.smartChartTileConfig?.band1?.config_filter &&
                Object.keys(this.props?.smartChartTileConfig?.band1?.config_filter).length > 0) ||
                (this.props?.smartChartTileConfig?.config_filter && Object.keys(this.props?.smartChartTileConfig?.config_filter).length > 0) ||
                this.props?.smartChartTileConfig?.band1?.mfilter?.asset_ids?.length === 0 ||
                this.props?.smartChartTileConfig?.asset_ids?.length === 0) &&
            this.state?.initialFiltersSetForSmartChart
        ) {
            this.selectWholeAssets();
        }
        this.setState({
            initialFiltersSetForSmartChart: false
        });
        return true;
    };

    // Mobile Asset Dashboard filters belong to the Mobile Asset table — never applied to this one
    getAssetDashboardTableFilterParams = () => {
        const assetTableFilters = this.props.assetDashboardReducer?.assetTableFilters || {};
        return this.isAssetDashboardFiltered && !isMobileAssetDashboard(assetTableFilters) ? assetTableFilters : {};
    };

    getAssetDashboardAppliedFilterTags = () => {
        if (!this.isAssetDashboardFiltered) return [];
        const locationState = this.state.locationState && typeof this.state.locationState === "object" ? this.state.locationState : {};
        return getCombinedAssetDashboardFilterTags(
            this.getAssetDashboardTableFilterParams(),
            locationState,
            this.props.assetReducer?.assetDynamicFields?.asset_custom_field
        );
    };

    getAssetChartNavigationFilterCount = () => {
        if (!this.isAssetDashboardFiltered) return 0;
        const locationState = this.state.locationState && typeof this.state.locationState === "object" ? this.state.locationState : {};
        return getAssetChartNavigationFilterCount(locationState);
    };

    getChartNavigationParams = (locationState = {}) => {
        const normalizedLocationState = locationState && typeof locationState === "object" ? locationState : {};
        const {
            match: {
                params: { section }
            }
        } = this.props;
        const hasChartNavState =
            !isEmpty(normalizedLocationState) &&
            !normalizedLocationState.isInitialView &&
            !this.props.isAssignView &&
            section !== "imageInfo" &&
            !this.props.isSmartChartView;

        if (!hasChartNavState) {
            return {};
        }

        // Chart slice fields (condition, age range, etc.) for API + applied-filter tags
        const chartNavParams = getAssetChartNavigationApiParams(normalizedLocationState);

        // Charts & Graphs: also pass master filters from location state (legacy path)
        if (normalizedLocationState.from === "charts") {
            return {
                ...getAssetDashboardAssetTableFilters(normalizedLocationState),
                ...chartNavParams
            };
        }

        return chartNavParams;
    };

    buildAssetTableApiParams = (pageParams = {}, locationState = {}) => {
        let apiParams = mergeAssetDashboardFiltersIntoParams(
            pageParams,
            this.isAssetDashboardFiltered ? this.getAssetDashboardTableFilterParams() : {}
        );
        const chartNavParams = this.getChartNavigationParams(locationState);
        if (Object.keys(chartNavParams).length) {
            apiParams = { ...apiParams, ...chartNavParams };
        }
        if (this.isAssetDashboardFiltered) {
            apiParams = { ...apiParams, from: "assetDashboard" };
        }
        return apiParams;
    };

    buildAssetTableDropdownApiParams = (pageParams = {}, searchKey = "", appliedPageParams = null) => {
        let apiParams = mergeAssetDashboardFiltersForDropdownApi(
            pageParams,
            this.isAssetDashboardFiltered ? this.getAssetDashboardTableFilterParams() : {},
            searchKey,
            appliedPageParams
        );
        const locationState = this.state.locationState && typeof this.state.locationState === "object" ? this.state.locationState : {};
        const chartNavParams = this.getChartNavigationParams(locationState);
        if (Object.keys(chartNavParams).length) {
            apiParams = { ...apiParams, ...chartNavParams };
        }
        if (this.isAssetDashboardFiltered) {
            apiParams = { ...apiParams, from: "assetDashboard" };
        }
        return apiParams;
    };

    getMasterFilterDropdownParams = (pageParams = {}, searchKey = "") => {
        const normalizedParams = this.normalizeAssetDynamicFieldParams(pageParams);
        const { subParams } = this.getScopedAssetParams(normalizedParams);

        return this.buildAssetTableDropdownApiParams(subParams, searchKey, {
            list: subParams.list,
            filters: subParams.filters,
            has_image: subParams.has_image,
            verified_survey: subParams.verified_survey
        });
    };

    getAssetChartNavigationParams = (locationState = {}) => this.buildAssetTableApiParams({}, locationState);

    shouldUseAssetChartDataApi = (locationState = {}) => {
        const hasAssetDashboardFilters = Object.keys(this.getAssetDashboardTableFilterParams()).length > 0;
        const normalizedLocationState = locationState && typeof locationState === "object" ? locationState : {};
        const {
            match: {
                params: { section }
            }
        } = this.props;
        const hasChartNavState =
            !isEmpty(normalizedLocationState) &&
            !normalizedLocationState.isInitialView &&
            !this.props.isAssignView &&
            section !== "imageInfo" &&
            !this.props.isSmartChartView;

        return hasChartNavState || (this.isAssetDashboardFiltered && hasAssetDashboardFilters);
    };

    handleScrollPosition = () => {
        const scrollPosition = this.props.assetReducer.scrollPosition;
        if (scrollPosition && this.tableRef?.current) {
            this.tableRef.current.scrollTo(0, parseInt(scrollPosition));
            this.props.setAssetScrollPosition(0);
        }
    };

    selectWholeAssets = async () => {
        this.setState({ isLoading: true });
        const { isSmartChartView = false } = this.props;
        const params = this.state.params;
        const locationState = this.state.locationState && typeof this.state.locationState === "object" ? this.state.locationState : {};
        const {
            match: {
                params: { section }
            }
        } = this.props;
        const { subParams } = this.getScopedAssetParams(params);

        await this.props.getAllAssetIds({
            ...this.buildAssetTableApiParams(subParams, locationState)
        });
        const { recommendation_ids } = this.props.assetReducer.getWholeAssetIdsResponse;
        let tempSelected = [];
        recommendation_ids?.length &&
            recommendation_ids.forEach((id, index) => {
                tempSelected.push({ id, index });
            });
        await this.setState({ selectedAssetsId: [] });
        await this.setState({ selectedAssetsId: tempSelected, isLoading: false });
        this.updateEntityParams();
    };

    updateWildCardFilter = async newFilter => {
        const { params, paginationParams } = this.state;
        await this.setState({
            params: {
                ...params,
                offset: 0,
                filters: newFilter
            },
            paginationParams: {
                ...paginationParams,
                currentPage: 0
            },
            ...(this.props?.isSmartChartView ? { selectedAssetsId: [] } : {})
        });
        this.updateEntityParams();
        await this.refreshDataList();
    };

    updateEntityParams = async () => {
        if (this.props.match.params.tab === "assets" || this.props.isSmartChartView || this.props.match.params.tab === "mr-assets") {
            const {
                filterParams,
                tableData,
                historyParams,
                historyPaginationParams,
                selectedRowId,
                wildCardFilterParams,
                paginationParams,
                params,
                locationState,
                parentSectionId,
                selectedAssetsId,
                tableDataExportFilters
            } = this.state;
            let entityParams = {
                entity: "assets",
                paginationParams,
                params,
                wildCardFilterParams,
                filterParams,
                tableConfig: tableData.config,
                selectedRowId,
                historyPaginationParams,
                historyParams,
                locationState,
                parentSectionId,
                selectedAssetsId,
                tableDataExportFilters
            };
            if (this.props.isSmartChartView) {
                const { section } = this.props.match.params;
                entityParams = { [this.props?.isSurveyView ? "survey" : section]: entityParams };
            }
            await this.props.updateDataEntityParams(entityParams);
        }
    };

    resetAllFilters = async () => {
        this.setState({ isLoading: true });
        await new Promise(resolve => setTimeout(resolve, 1));
        await this.setState({
            paginationParams: {
                totalPages: 0,
                perPage: 40,
                currentPage: 0,
                totalCount: 0
            },
            params: {
                ...this.state.params,
                limit: 40,
                offset: 0,
                search: "",
                project_id: null,
                filters: null,
                list: null,
                recommendation_assigned_true: null,
                guid_assigned: null,
                has_image: null,
                verified_survey: null
            },
            wildCardFilterParams: {},
            filterParams: {},
            selectedRowId: null,
            tableDataExportFilters: {},
            ...(this.props?.isSmartChartView ? { selectedAssetsId: [] } : {})
        });
        this.updateEntityParams();
        await this.refreshDataList();
        this.setState({ isLoading: false });
    };

    resetSort = async () => {
        this.setState({ isLoading: true });
        await new Promise(resolve => setTimeout(resolve, 1));
        await this.setState({
            params: {
                ...this.state.params,
                order: null
            }
        });
        this.updateEntityParams();
        await this.refreshDataList();
        this.setState({ isLoading: false });
    };
    resetAll = async (hasRefresh = true) => {
        this.setState({ isLoading: true });
        await new Promise(resolve => setTimeout(resolve, 1));
        await this.setState({
            selectedRegion: null,
            paginationParams: {
                totalPages: 0,
                perPage: 40,
                currentPage: 0,
                totalCount: 0
            },
            params: {
                ...this.state.params,
                limit: 40,
                offset: 0,
                search: "",
                project_id: null,
                filters: null,
                recommendation_assigned_true: null,
                guid_assigned: null,
                has_image: null,
                verified_survey: null,
                order: null,
                list: null,
                asset_ids: null
            },
            tableData: {
                ...this.state.tableData,
                data: []
                // config: _.cloneDeep(assetTableData.config)
            },

            wildCardFilterParams: {},
            filterParams: {},
            selectedRowId: null,
            tableDataExportFilters: {},
            selectedAssetsId: []
        });
        this.updateEntityParams();
        if (hasRefresh) {
            await this.refreshDataList();
            this.setState({ isLoading: false });
        }
    };
    isColunmVisibleChanged = () => {
        const { tableConfigChanged } = this.state;
        return tableConfigChanged;
    };

    normalizeAssetDynamicFieldParams = params => {
        if (!params?.searchKey?.startsWith("dynamic_fields.")) return params;

        const fieldName = params.searchKey.slice("dynamic_fields.".length);
        return {
            ...params,
            searchKey: `asset__${fieldName}`,
            is_dynamic: true
        };
    };

    remapAssetDynamicFieldList = list => {
        if (!list || typeof list !== "object") return list;

        return Object.entries(list).reduce((remappedList, [key, value]) => {
            if (key.startsWith("dynamic_fields.")) {
                remappedList[`asset_dynamic_field__${key.slice("dynamic_fields.".length)}`] = value;
            } else {
                remappedList[key] = value;
            }
            return remappedList;
        }, {});
    };

    getListForCommonFilter = async (params, isRecommendationList = false) => {
        let { search, filters, list, recommendation_assigned_true, guid_assigned, has_image, verified_survey } = this.state.params;

        // getListForCommonFilter-specific: omit the list key currently being searched
        let cleanedList = list;
        if (cleanedList) {
            const { [params.searchKey]: _omit, ...restList } = cleanedList || {};
            cleanedList = Object.keys(restList)?.length ? restList : null;
        }

        const baseParams = this.normalizeAssetDynamicFieldParams({
            ...params,
            search,
            filters,
            ...(isRecommendationList ? {} : { recommendation_assigned_true }),
            guid_assigned,
            has_image,
            verified_survey,
            list: cleanedList
        });

        const { subParams } = this.getScopedAssetParams(baseParams);
        const appliedPageParams = { list, filters, has_image, verified_survey };
        await this.props.getListForCommonFilter(
            this.buildAssetTableDropdownApiParams(subParams, params.searchKey || params.field, appliedPageParams),
            isRecommendationList
        );
        return this.props.assetReducer.getListForCommonFilterResponse || {};
    };

    updateCommonFilter = async (commonFilters, exportFilters) => {
        await this.setState({
            params: {
                ...this.state.params,
                offset: 0,
                list: commonFilters
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            },
            tableDataExportFilters: exportFilters,
            ...(this.props?.isSmartChartView ? { selectedAssetsId: [] } : {})
        });
        this.updateEntityParams();
        await this.refreshDataList();
    };

    updateTableSortFilters = async searchKey => {
        if (this.state.params.order) {
            await this.setState({
                params: {
                    ...this.state.params,
                    order: {
                        ...this.state.params.order,
                        [searchKey]: this.state.params.order[searchKey] === "desc" ? "asc" : "desc"
                    }
                }
            });
        } else {
            await this.setState({
                params: {
                    ...this.state.params,
                    order: { [searchKey]: "asc" }
                }
            });
        }
        this.updateEntityParams();
        await this.refreshDataList();
    };

    handleColumnVisibilityApply = (tableConfig, actionType = "") =>
        this.handleHideColumn(mergeAdminHiddenColumns(this.state.tableData, tableConfig), actionType);

    handleHideColumn = async (tableConfig, actionType = "") => {
        this.setState({ isLoading: true });
        await new Promise(resolve => setTimeout(resolve, 1));
        //unpin hidden columns
        const { keys, config } = tableConfig;

        await this.setState({
            tableData: {
                ...this.state.tableData,
                keys,
                config
            }
        });
        await this.updateEntityParams();
        if (actionType !== "temp") {
            this.saveUserTableConfig();
        }
        this.setState({ isLoading: false });
    };

    updateSelectedRow = async rowId => {
        await this.setState({
            selectedRowId: rowId
        });
        await this.updateEntityParams();
    };

    handlePerPageChange = async e => {
        const { paginationParams, params } = this.state;
        await this.setState({
            paginationParams: {
                ...paginationParams,
                perPage: e.target.value,
                currentPage: 0
            },
            params: {
                ...params,
                offset: 0,
                limit: e.target.value
            }
        });
        await this.refreshDataList();
    };

    handlePageClick = async page => {
        this.setState({ isLoading: true });
        await new Promise(resolve => setTimeout(resolve, 1));
        const { paginationParams, params } = this.state;
        await this.setState({
            paginationParams: {
                ...paginationParams,
                currentPage: page.selected
            },
            params: {
                ...params,
                // offset: page.selected * paginationParams.perPage
                offset: page.selected + 1
            }
        });
        await this.refreshDataList();
        this.setState({ isLoading: false });
    };

    showEditPage = dataId => {
        const {
            basicDetails,
            clientId,
            history,
            location: { search },
            match: {
                params: { section, tab }
            }
        } = this.props;

        const query = qs.parse(search);
        let client_id = "";
        let pid = "";
        let is_mr = query?.is_mr ?? "";
        if (this.tableRef?.current?.scrollTop) {
            this.props.setAssetScrollPosition(this.tableRef.current.scrollTop);
        }
        this.setState({
            selectedData: dataId
        });
        if (section === "assetInfo" && tab === "basicdetails" && !query?.is_mr) {
            client_id = query.client_id ?? query?.c_id;
        } else if (section === "assetinfo" && !query?.is_mr) {
            client_id = clientId ?? query?.c_id ?? query?.client_id;
        } else if (section === "assetinfo" || section === "mobrecomsinfo" || query?.is_mr) {
            client_id = clientId ?? query?.c_id;
            pid = query?.pid;
            is_mr = true;
        } else {
            client_id = basicDetails?.client?.id;
        }
        let path = `/assets/edit/${dataId}?c_id=${client_id}${pid ? `&pid=${pid}` : ""}${is_mr ? `&is_mr=${is_mr}` : ""}`;
        addToBreadCrumpData({
            key: "edit",
            name: `Edit Asset`,
            path
        });
        history.push(path);
    };

    showAddForm = () => {
        const { history } = this.props;
        this.setState({
            selectedData: null
        });
        let selectedClient = "";
        let selectedRegion = "";
        let selectedSite = "";
        let selectedBuilding = "";
        if (this.props.clientId) {
            selectedClient = this.props.clientId;
        }
        if (this.props.regionId) {
            selectedClient = this.props.basicDetails?.client?.id;
            selectedRegion = this.props.regionId;
        }
        if (this.props.siteId) {
            selectedClient = this.props.basicDetails?.client?.id;
            selectedRegion = this.props.basicDetails?.region?.id;
            selectedSite = this.props.siteId;
        }
        if (this.props.buildingId) {
            selectedClient = this.props.basicDetails?.client?.id;
            selectedRegion = this.props.basicDetails?.region?.id;
            selectedSite = this.props.basicDetails?.site?.id;
            selectedBuilding = this.props.buildingId;
        }
        addToBreadCrumpData({ key: "add", name: "Add Asset", path: "/assets/add" });
        if (this.props?.isMobilecomAssetView) {
            history.push(
                `/assets/add?c_id=${selectedClient}&pid=${this.props.basicDetails?.project?.id}&is_mr=true&s_id=${this.props.match.params.id}`
            );
        } else history.push(`/assets/add?r_id=${selectedRegion}&c_id=${selectedClient}&b_id=${selectedBuilding}&s_id=${selectedSite}`);
    };

    showViewModal = () => {
        this.setState({
            showViewModal: true
        });
    };

    toggleWildCardFilter = () => {
        const { showWildCardFilter } = this.state;
        this.setState({
            showWildCardFilter: !showWildCardFilter
        });
    };

    handleAddData = async data => {
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        this.setState({
            isLoading: true
        });
        await this.props.addData(data);
        const { error, message, asset_id } = this.props.assetReducer.addDataResponse;
        if (error) {
            this.setState(
                {
                    alertMessage: error,
                    isLoading: false
                },
                () => this.showAlert()
            );
        } else {
            if (query?.isRecomAsset) {
                sessionStorage.setItem("lastCreatedAssetId", asset_id);
            }
            await this.setState({
                alertMessage: message,
                isLoading: false
            });
            if (data?.is_mr) {
                const currentQuery = qs.parse(search);
                const newParams = {
                    ...currentQuery,
                    ...(query?.c_id ? { client_id: query.c_id } : {}),
                    ...(query?.pid ? { pid: query.pid } : {}),
                    ...(query?.s_id ? { s_id: query.s_id } : {}),
                    ...(data?.is_mr ? { is_mr: true } : {})
                };
                const queryString = qs.stringify(newParams) ? `?${qs.stringify(newParams)}` : "";

                if (!currentQuery?.is_assignedRecom) popBreadCrumpOnPageClose();
                addToBreadCrumpData({
                    key: "Name",
                    name: data?.asset_name ?? "",
                    path: `/assets/assetInfo/${asset_id}/basicdetails${queryString}`
                });
                addToBreadCrumpData({
                    key: "info",
                    name: "Basic Details",
                    path: `/assets/assetInfo/${asset_id}/basicdetails${queryString}`
                });
                history.push(`/assets/assetInfo/${asset_id}/${`basicdetails${queryString}`}`);
                await this.refreshDataList();
                addTableSliderDataToBreadcrumb(this.state.tableData?.data || []);
                this.showAlert();
            } else {
                await this.refreshDataList();
                this.showAlert();
                this.cancelForm();
            }
        }
    };

    showAlert = () => showAlertUtil(this.state.alertMessage);

    handleUpdateData = async data => {
        const {
            match: {
                params: { id }
            },
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        this.setState({
            isLoading: true
        });
        await this.props.updateData(id, data);
        const { updateDataResponse } = this.props.assetReducer;
        if (updateDataResponse.error) {
            this.setState({ alertMessage: updateDataResponse.error, isLoading: false }, () => this.showAlert());
        } else {
            if (query?.isRecomAsset) {
                sessionStorage.setItem("lastCreatedAssetId", id);
            }
            await this.setState({
                alertMessage: updateDataResponse && updateDataResponse.message
            });
            await this.refreshDataList();
            this.setState({
                isLoading: false
            });
            this.showAlert();
            this.cancelForm();
        }
    };

    handleGlobalSearch = async search => {
        const { params } = this.state;
        await this.setState({
            params: {
                ...params,
                offset: 0,
                search
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            }
        });
        await this.refreshDataList();
    };

    showInfoPage = (id, projectId, rowData, client_id, isVerification, isMrAsset = false, isNextPrev = false) => {
        if (this.tableRef?.current?.scrollTop) {
            this.props.setAssetScrollPosition(this.tableRef.current.scrollTop);
        }
        const { history } = this.props;
        const { id: clientId } = this.props.match.params;
        let selectedClient = this.props.clientId || client_id || clientId;
        const {
            location: { search = "" },
            isMobilecomAssetView = false
        } = this.props;
        const isMobileAssets = qs.parse(search)?.is_mr === "true" || isMrAsset || isMobilecomAssetView;
        const parsedQuery = qs.parse(search);
        const currentParams = qs.parse(search);
        const newParams = {
            ...currentParams,
            ...(selectedClient || rowData?.client?.id ? { client_id: selectedClient ?? rowData?.client?.id } : {}),
            ...(parsedQuery?.pid ? { pid: parsedQuery.pid } : {}),
            ...(isMobileAssets ? { is_mr: true } : {}),
            ...(isMobileAssets ? { s_id: parsedQuery?.s_id ?? clientId } : {})
        };
        const queryString = qs.stringify(newParams) ? `?${qs.stringify(newParams)}` : "";
        this.setState({
            selectedData: id,
            infoTabsData: [
                {
                    key: "basicdetails",
                    name: "Asset",
                    path:
                        this.props.isAssignAssetView || isVerification
                            ? `/assets/assetInfo/${id}/basicdetails?client_id=${selectedClient ?? rowData?.client?.id}&verification=true`
                            : `/assets/assetInfo/${id}/basicdetails${queryString}`
                },
                {
                    key: "recommendations",
                    name: "Recommendations",
                    path: `/assets/assetInfo/${id}/recommendations${queryString}`
                },
                {
                    key: "infoimages",
                    name: "Images",
                    path: `/assets/assetInfo/${id}/infoimages${queryString}`,
                    show: checkPermission("forms", permissions.ASSET_IMAGES, "view")
                },
                ...(isMobileAssets
                    ? [
                          {
                              key: "mobile-recommendations",
                              name: "Mobile Recommendations",
                              path: `/assets/assetInfo/${id}/mobile-recommendations${queryString}`
                          }
                      ]
                    : [])
            ]
        });
        const tableSliderData = getTableSliderData();
        isNextPrev && popBreadCrumpRecData();

        if (rowData) {
            addToBreadCrumpData({
                key: "Name",
                name: this.props.isAssignAssetView || isVerification ? rowData?.code : rowData?.asset_name,
                path:
                    this.props.isAssignAssetView || isVerification
                        ? `/assets/assetInfo/${id}/basicdetails?client_id=${selectedClient ?? rowData?.client?.id}&verification=true`
                        : `/assets/assetInfo/${id}/basicdetails${queryString}`,
                ...(isNextPrev ? { tableSliderData } : {})
            });
            addToBreadCrumpData({
                key: "info",
                name: "Basic Details",
                path:
                    this.props.isAssignAssetView || isVerification
                        ? `/assets/assetInfo/${id}/basicdetails?client_id=${selectedClient ?? rowData?.client?.id}&verification=true`
                        : `/assets/assetInfo/${id}/basicdetails${queryString}`
            });
            if (rowData?.id && !isNextPrev) {
                addTableSliderDataToBreadcrumb(this.state.tableData?.data || []);
            }
        }
        this.updateSelectedRow(id);
        let tabKeyList = ["basicdetails", "recommendations", "infoimages", "weightedScore"];
        history.push(
            `/assets/assetInfo/${id}/${
                tabKeyList.includes(this.props.match.params.tab)
                    ? this.props?.isAssignAssetView || isVerification
                        ? `${this.props.match.params.tab}?client_id=${selectedClient}&verification=true`
                        : `${this.props.match.params.tab}${queryString}`
                    : this.props?.isAssignAssetView || isVerification
                      ? `basicdetails?client_id=${selectedClient}&verification=true`
                      : `basicdetails${queryString}`
            }`
        );
    };

    getDataById = async () => {
        await this.props.getAssetDataById(this.state.selectedData);
        return this.props.assetReducer.getDataByIdResponse;
    };

    getLogData = async () => {
        const { historyParams, historyPaginationParams, logData, selectedData } = this.state;
        await this.props.getAllDataLogs(selectedData, historyParams);
        const {
            getDataLogsResponse: { logs, count, error }
        } = this.props.assetReducer;
        if (error) {
            this.setState({ alertMessage: error }, () => this.showAlert());
        } else {
            this.setState({
                logData: {
                    ...logData,
                    data: logs
                },
                historyPaginationParams: {
                    ...historyPaginationParams,
                    totalCount: count,
                    totalPages: Math.ceil(count / historyPaginationParams.perPage)
                }
            });
        }
    };

    handlePerPageChangeHistory = async e => {
        const { historyPaginationParams, historyParams } = this.state;
        await this.setState({
            historyPaginationParams: {
                ...historyPaginationParams,
                perPage: e.target.value,
                currentPage: 0
            },
            historyParams: {
                ...historyParams,
                offset: 0,
                limit: e.target.value
            }
        });
        await this.getLogData();
    };

    handlePageClickHistory = async page => {
        const { historyPaginationParams, historyParams } = this.state;
        await this.setState({
            historyPaginationParams: {
                ...historyPaginationParams,
                currentPage: page.selected
            },
            historyParams: {
                ...historyParams,
                offset: page.selected + 1
            }
        });
        await this.getLogData();
    };

    handleGlobalSearchHistory = async search => {
        const { historyParams, historyPaginationParams } = this.state;
        await this.setState({
            historyParams: {
                ...historyParams,
                offset: 0,
                search
            },
            historyPaginationParams: {
                ...historyPaginationParams,
                currentPage: 0
            }
        });
        await this.getLogData();
    };

    handleDeleteLog = async (id, choice) => {
        this.setState({
            showConfirmModalLog: true,
            selectedLog: id,
            isRestoreOrDelete: choice
        });
    };
    handleRestoreLog = async (id, choice) => {
        this.setState({
            showConfirmModalLog: true,
            selectedLog: id,
            isRestoreOrDelete: choice
        });
    };

    renderConfirmationModalLog = () => {
        const { showConfirmModalLog, isRestoreOrDelete } = this.state;
        if (!showConfirmModalLog) return null;
        if (isRestoreOrDelete === "delete") {
            return (
                <Portal
                    body={
                        <ConfirmationModal
                            heading={"Do you want to delete this log?"}
                            message={"This action cannot be reverted, are you sure that you need to delete this item?"}
                            onNo={() => this.setState({ showConfirmModalLog: false })}
                            onYes={this.deleteLogOnConfirm}
                        />
                    }
                    onCancel={() => this.setState({ showConfirmModalLog: false })}
                />
            );
        } else {
            return (
                <Portal
                    body={
                        <ConfirmationModal
                            heading={"Do you want to restore this log?"}
                            message={"This action cannot be reverted, are you sure that you need to restore this item?"}
                            onNo={() => this.setState({ showConfirmModalLog: false })}
                            onYes={this.restoreLogOnConfirm}
                            isRestore={true}
                            type={"restore"}
                        />
                    }
                    onCancel={() => this.setState({ showConfirmModalLog: false })}
                />
            );
        }
    };

    deleteLogOnConfirm = async () => {
        const { selectedLog } = this.state;
        await this.props.deleteDataLog(selectedLog);
        const { error, message, success, detail = null } = this.props.assetReducer.deleteDataLogResponse;
        if (!success) {
            this.setState({ alertMessage: typeof detail === "string" ? detail : error }, () => this.showAlert());
        } else {
            this.setState({ alertMessage: message }, () => this.showAlert());
        }
        await this.getLogData();
        this.setState({
            showConfirmModalLog: false,
            selectedLog: null
        });
    };

    restoreLogOnConfirm = async selectedLog => {
        await this.props.restoreDataLog(selectedLog);
        const { error, message, success } = this.props.assetReducer.restoreDataLogResponse;
        if (!success) {
            this.setState({ alertMessage: error }, () => this.showAlert());
        } else {
            this.setState({ alertMessage: message }, () => this.showAlert());
        }
        this.setState({
            showConfirmModalLog: false,
            selectedLog: null,
            isHistory: false
        });
        this.refreshDataList();
    };

    exportTableXl = async (exportparamValue = {}) => {
        this.setState({ tableLoading: true });
        const {
            params: {
                search = "",
                filters = {},
                list = {},
                order = {},
                deleted,
                active,
                recommendation_assigned_true,
                guid_assigned,
                has_image,
                verified_survey,
                asset_ids
            },
            tableData: { keys = [], config = {} } = {},
            tableDataExportFilters = {},
            paginationParams: { totalCount = 0 } = {}
        } = this.state;
        const locationState = this.state.locationState && typeof this.state.locationState === "object" ? this.state.locationState : {};

        const { has_image: _omitHasImg, verified_survey: _omitVerSur, ...exportList } = list || {};

        const exportParams = {
            search,
            filters,
            list: exportList,
            order,
            deleted,
            active,
            recommendation_assigned_true,
            guid_assigned,
            has_image,
            asset_ids,
            verified_survey: typeof verified_survey === "boolean" ? (verified_survey ? "yes" : "no") : verified_survey
        };

        if (this.props.isAssignView || this.props.isProjectAssetView || this.props?.isMobilecomAssetView) {
            exportParams.client_id = this.props.clientId;
        }

        const {
            match: {
                params: { section = "", id = "" }
            }
        } = this.props;
        const { subParams } = this.getScopedAssetParams(exportParams);

        const clientIds = subParams.client_id ? [subParams.client_id] : exportParams.client_id ? [exportParams.client_id] : [];
        const regionIds = subParams.region_id ? [subParams.region_id] : [];
        const siteIds = subParams.site_id ? [subParams.site_id] : [];
        const buildingIds = subParams.building_id ? [subParams.building_id] : [];
        const scope = section ? section.slice(0, -4) : "";

        const tableSettings = keys
            .filter(key => config?.[key]?.label)
            .map(keyItem => {
                const {
                    isVisible = false,
                    label = "",
                    isDynamicField = false,
                    isYear = false,
                    searchKey,
                    smartChartWildCardFilterKey
                } = config?.[keyItem] || {};

                let keyValue;
                if (isYear) keyValue = parseInt(label);
                else if (isDynamicField) keyValue = keyItem;
                else keyValue = smartChartWildCardFilterKey || searchKey || keyItem;

                let setting = {
                    key: keyValue,
                    heading: (label || "").toString().toUpperCase(),
                    is_active: isVisible
                };
                if (!isYear && !isDynamicField) setting.is_static_field = true;
                if (isDynamicField) setting.is_asset_dynamic_field = isDynamicField;
                if (isYear) setting.is_year = isYear;
                return setting;
            });

        const configFilter = {
            ...exportParams,
            ...subParams,
            ...this.buildAssetTableApiParams({}, locationState),
            ...this.getUpdatedCommonFilters(tableDataExportFilters || {}, exportList, Object.entries(config)),
            wildcard_filters: this.getUpdatedWildCardFilters(exportParams.filters),
            global_search: search || "",
            sort_by_order: { ...this.getUpdatedSortFilters(order || {}) },
            order: order
        };
        const configFilterNames = {
            list: list || null,
            filters: filters || {},
            tableDataExportFilters: tableDataExportFilters || {},
            order: order || null,
            maintenance_year: this.state.params?.maintenance_year || []
        };
        const { settings_id = null, ...resetExportParamValue } = exportparamValue ?? {};

        const data = {
            asset_band: {
                band1: {
                    table_settings: tableSettings,
                    mfilter: {
                        ...(clientIds.length && { client_ids: clientIds }),
                        ...(regionIds.length && { region_ids: regionIds }),
                        ...(siteIds.length && { site_ids: siteIds }),
                        ...(buildingIds.length && { building_ids: buildingIds })
                    },
                    config_filter: configFilter,
                    config_filter_names: configFilterNames,
                    ...(settings_id ? { settings_id } : {})
                }
            },
            is_excel: true,
            number_of_asset: totalCount || 0,
            export_from: scope,
            ...(this.isAssetDashboardFiltered ? { from: "assetDashboard" } : {}),
            user_id: localStorage.getItem("userId") || "",
            ...(this.props?.isMobilecomAssetView ? { survey_recommendation_id: id } : {}),
            ...resetExportParamValue
        };
        const outcome = await this.props.exportData(data);
        const { error, message_status } = this.props.assetReducer.dataExportResponse || {};
        if (message_status || error) {
            this.setState({ alertMessage: message_status || error }, () => this.showLongAlert());
        }
        this.setState({ tableLoading: false, showExportModal: false });
        // Returned so an Otto-run export can report what actually happened (downloaded vs queued vs failed);
        // the popup's own Download File buttons ignore it, exactly as on Recommendations.
        return outcome;
    };

    getUpdatedCommonFilters = (filters = {}, list = {}, tableConfig = []) => {
        if (!filters || typeof filters !== "object" || !tableConfig?.length) return {};

        return Object.entries(filters).reduce((acc, [filterKey, filterValue]) => {
            if (filterValue == null || (Array.isArray(filterValue) && filterValue.every(v => v == null))) {
                return acc;
            }
            const configEntry = tableConfig.find(([, value]) => value?.filterIdKey === filterKey || value?.searchKey === filterKey);
            if (!configEntry) {
                return acc;
            }
            const [, configValue] = configEntry;
            const apiKey = configValue?.filterIdKey || configValue?.searchKey || "";
            if (!apiKey) {
                return acc;
            }

            if (apiKey === "buildings_descriptions") {
                return {
                    ...acc,
                    [apiKey]: list && list["buildings.description"]
                };
            }

            return {
                ...acc,
                [apiKey]: Array.isArray(filterValue) ? filterValue : [filterValue]
            };
        }, {});
    };

    getUpdatedSortFilters = (filters = {}) => {
        const {
            tableData: { config }
        } = this.state;
        const configArr = Object.entries(config || {});
        return Object.entries(filters).reduce((filtersData, [filterKey, filterValue]) => {
            let updatedData = { order: filterValue };
            const configItemEntry = configArr.find(([_, value]) => value?.searchKey === filterKey);
            if (!configItemEntry) return filtersData;
            const configItem = configItemEntry[1];
            const finalKey = configItem.smartChartWildCardFilterKey || configItem.searchKey || "";
            if (!finalKey) return filtersData;
            return {
                ...filtersData,
                [finalKey]: { ...updatedData }
            };
        }, {});
    };

    getUpdatedWildCardFilters = (filters = {}) => {
        const {
            tableData: { config }
        } = this.state;
        const tableConfigArr = Object.entries(config || {});
        if (!tableConfigArr.length) return {};
        if (!filters || typeof filters !== "object") return {};
        return Object.entries(filters).reduce((filtersData, [currentDataKey, currentDataValue]) => {
            let updatedData = { ...currentDataValue } || {};
            let foundEntry = tableConfigArr.find(([key, value]) => value?.searchKey === currentDataKey);
            if (!foundEntry) return filtersData;
            const foundConfig = foundEntry[1];
            let finalKey = foundConfig.smartChartWildCardFilterKey || foundConfig.searchKey || "";
            if (foundConfig.type === "date" && currentDataValue?.key !== null) {
                updatedData = {
                    ...updatedData,
                    key: {
                        from: moment(currentDataValue?.key?.from).format("YYYY-MM-DD"),
                        to: moment(currentDataValue?.key?.to).format("YYYY-MM-DD")
                    }
                };
            }
            if (finalKey && currentDataValue?.key !== null) {
                return {
                    ...filtersData,
                    [finalKey]: {
                        ...updatedData
                    }
                };
            }
            return filtersData;
        }, {});
    };

    exportCustomExcel = async () => {
        this.setState({ customExcelExportLoading: true });
        const {
            params: { search, filters, list, order, deleted, active, recommendation_assigned_true, guid_assigned, has_image, verified_survey }
        } = this.state;
        const {
            tableData: { keys, config }
        } = this.state;
        let hide_columns = [""];
        keys.map((keyItem, i) => {
            if (config && !config[keyItem]?.isVisible) {
                hide_columns.push(config[keyItem]?.label);
            }
        });
        let exportParams = {
            search,
            filters,
            list,
            order,
            deleted,
            active,
            hide_columns,
            recommendation_assigned_true,
            guid_assigned,
            has_image,
            verified_survey
        };

        if (exportParams.verified_survey === true || exportParams.verified_survey === false) {
            exportParams.verified_survey = exportParams.verified_survey ? "yes" : "no";
        }

        const { section, id } = this.props.match.params;
        let subParams = {};
        if (this.props.isProjectAssetView || this.props?.isMobilecomAssetView) {
            const id = this.props.clientId;
        }
        switch (section) {
            case "assetinfo":
                subParams.client_id = id;
                break;
            case "regioninfo":
                subParams.region_id = id;
                break;
            case "siteinfo":
                subParams.site_id = id;
                break;
            case "buildinginfo":
                subParams.building_id = id;
                break;
            case "projectinfo":
                subParams.client_id = this.props.clientId;
                break;

            default:
                break;
        }
        if (this.props.match.params.subTab === "assigned-assets" && this.props?.assignedAssets)
            subParams = { ...subParams, asset_survey_project_id: id };
        if (this.props?.isMobilecomAssetView) subParams = { ...subParams, survey_recommendation_id: id };
        await this.props.exportCustomExcel({
            ...exportParams,
            ...subParams,
            ...this.buildAssetTableApiParams({}, this.state.locationState)
        });
        this.setState({
            customExcelExportLoading: false
        });
        if (this.props.assetReducer.dataExportResponse && this.props.assetReducer.dataExportResponse.error) {
            await this.setState({ alertMessage: this.props.assetReducer.dataExportResponse.error });
            this.showAlert();
        }
    };

    updateLogSortFilters = async searchKey => {
        if (this.state.historyParams.order) {
            await this.setState({
                historyParams: {
                    ...this.state.historyParams,
                    order: {
                        ...this.state.historyParams.order,
                        [searchKey]: this.state.historyParams.order[searchKey] === "desc" ? "asc" : "desc"
                    }
                }
            });
        } else {
            await this.setState({
                historyParams: {
                    ...this.state.historyParams,
                    order: { [searchKey]: "asc" }
                }
            });
        }
        this.updateEntityParams();
        await this.getLogData(this.props.match.params.id);
    };

    cancelForm = () => {
        popBreadCrumpOnPageClose();
        history.push(findPrevPathFromBreadCrumpData());
    };

    cancelInfoPage = () => {
        popBreadCrumpOnPageClose();
        history.push(findPrevPathFromBreadCrumpData() || `/assets`);
    };

    toggleHistory = async () => {
        this.setState({ isHistory: !this.state.isHistory });
    };

    handleDeleteData = async (id, deleted, rowData) => {
        if (!checkPermission("forms", "assets", "hard_delete") && rowData.status === "deleted") {
            this.setState(
                {
                    alertMessage: "You are not authorized to perform the Hard Delete !"
                },
                () => this.showAlert()
            );
        } else {
            this.setState({
                showConfirmModal: true,
                selectedData: id,
                isDeleted: rowData.status === "deleted"
            });
        }
    };

    renderConfirmationModal = () => {
        const { showConfirmModal, isDeleted } = this.state;
        if (!showConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Do you want to delete this Asset ?`}
                        message={"Are you sure that you need to delete this item?"}
                        onNo={() => this.setState({ showConfirmModal: false })}
                        onYes={isHardDelete => {
                            isHardDelete ? this.setState({ showHardDeleteConfirmationModal: true }) : this.deleteDataOnConfirm();
                        }}
                        isHard={checkPermission("forms", "assets", "hard_delete")}
                        isDeleted={isDeleted}
                    />
                }
                onCancel={() => this.setState({ showConfirmModal: false })}
            />
        );
    };

    renderHardDeleteConfirmationModal = () => {
        const { showHardDeleteConfirmationModal } = this.state;
        if (!showHardDeleteConfirmationModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Are you sure you want to permanently (Hard) delete this Asset?`}
                        type="cancel"
                        onNo={() => this.setState({ showHardDeleteConfirmationModal: false })}
                        onYes={() => {
                            this.setState({ showConfirmModal: false, showHardDeleteConfirmationModal: false });
                            this.deleteDataOnConfirm(true);
                        }}
                    />
                }
                onCancel={() => this.setState({ showHardDeleteConfirmationModal: false })}
            />
        );
    };

    deleteDataOnConfirm = async (hard_delete = false) => {
        const { selectedData } = this.state;
        this.setState({
            showConfirmModal: false,
            isLoading: true
        });
        let params = hard_delete ? { hard_delete } : {};
        await this.props.deleteData(selectedData, params);

        const { success, message, error } = this.props.assetReducer.deleteDataResponse;
        if (!success) {
            this.setState(
                {
                    alertMessage: message || error,
                    showConfirmModal: false
                },
                () => this.showLongAlert()
            );
        } else {
            this.setState({ alertMessage: message }, () => this.showLongAlert());

            if (this.props.match.path === "/assets/:section/:id/:tab") {
                this.cancelInfoPage();
            }
            this.refreshDataList();
        }
        this.setState({
            isLoading: false
        });
    };

    showRestoreModal = async id => {
        this.setState({
            showRestoreConfirmModal: true,
            selectedData: id
        });
    };

    renderRestoreConfirmationModal = () => {
        const { showRestoreConfirmModal } = this.state;
        if (!showRestoreConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Do you want to restore this Asset?`}
                        message={""}
                        onNo={() => this.setState({ showRestoreConfirmModal: false })}
                        onYes={this.restoreAssetOnConfirm}
                        type={"restore"}
                        isRestore={true}
                    />
                }
                onCancel={() => this.setState({ showRestoreConfirmModal: false })}
            />
        );
    };

    restoreAssetOnConfirm = async () => {
        const { selectedData } = this.state;
        this.setState({
            showRestoreConfirmModal: false,
            isLoading: true
        });
        await this.props.restoreData(selectedData);

        const { success, message, error } = this.props.assetReducer.restoreDataResponse;
        if (!success) {
            this.setState(
                {
                    alertMessage: message || error,
                    showConfirmModal: false
                },
                () => this.showLongAlert()
            );
        } else {
            this.setState({ alertMessage: message }, () => this.showLongAlert());
            if (this.props.match.path === "/assets/:section/:id/:tab") {
                this.cancelInfoPage();
            }
            this.refreshDataList();
        }
        this.setState({
            isLoading: false
        });
    };

    showLongAlert = () => showAlertUtil(this.state.alertMessage, true);
    getAllImageList = async (assetId, params) => {
        await this.props.getAllImages(assetId, params);
        const {
            assetReducer: { getAllImagesResponse }
        } = this.props;
        await this.setState({
            imageResponse: getAllImagesResponse
        });
        return true;
    };

    uploadImages = async (imageData = {}) => {
        const { selectedData } = this.state;
        await this.props.uploadAssetImage(imageData, selectedData || this.props.match.params.id);
        return true;
    };
    updateAssetImages = async imageData => {
        await this.props.updateAssetImage(imageData);
        return true;
    };

    deleteImages = async imageId => {
        await this.props.deleteAssetImage(imageId);
        return true;
    };

    handleSelectAsset = (data, isChecked) => {
        this.props.handleSelectAsset(data, isChecked);
    };

    filterByRecommendationAssigned = async value => {
        await this.setState({
            params: {
                ...this.state.params,
                offset: 0,
                recommendation_assigned_true: value || null
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            },
            ...(this.props?.isSmartChartView ? { selectedAssetsId: [] } : {})
        });
        this.updateEntityParams();
        await this.refreshDataList();
    };

    onePagerExport = data => {
        this.setState({
            showOnePagerExportModal: true,
            selectedAssetData: data
        });
    };

    renderAssetOnePagerExportModal = () => {
        const { showOnePagerExportModal, exportLoader } = this.state;
        if (!showOnePagerExportModal) return null;
        return (
            <Portal
                body={
                    <ExportModal
                        onCancel={() => this.setState({ showOnePagerExportModal: false })}
                        viewExportSettings={() => this.setState({ showExportSettings: true })}
                        exportData={this.postExport}
                        exportLoader={exportLoader}
                    />
                }
                onCancel={() => this.setState({ showOnePagerExportModal: false })}
            />
        );
    };

    onSettingsSave = async data => {
        await this.props.postExportProperties(data);
        const message = this.props.assetReducer.postSettingsResponse?.message ?? "";
        await this.setState({ alertMessage: message });
        this.showAlert();
        this.props.getExportProperties({ client_id: data.client_id });
        this.setState({ showExportSettings: false });
    };

    renderAssetExportSettings = () => {
        const { showExportSettings } = this.state;
        if (!showExportSettings) return null;
        return (
            <Portal
                body={
                    <OnePagerModal
                        onCancel={() => this.setState({ showExportSettings: false })}
                        onSettingsSave={this.onSettingsSave}
                        saveLoader={this.props.assetReducer?.postSettingsLoader}
                    />
                }
                onCancel={() => this.setState({ showExportSettings: false })}
            />
        );
    };

    postExport = async type => {
        const { selectedAssetData } = this.state;
        this.setState({ showOnePagerExportModal: false });
        this.setState({ exportLoader: true });
        let params = { ...selectedAssetData, user_id: localStorage.getItem("userId") };
        if (this.props.assetReducer?.exportSettingsResponse?.data?.id)
            params = { ...params, property_id: this.props.assetReducer?.exportSettingsResponse?.data?.id };
        if (type === "pdf") {
            await this.props.exportAssetReportPdf({ ...params });
        } else {
            await this.props.exportAssetReportWord({ ...params });
        }
        this.setState({ exportLoader: false, showOnePagerExportModal: false });
    };

    showUploadDataModal = async (type = "normal") => {
        this.setState({
            showUploadDataModal: true,
            importType: type
        });
    };

    renderUploadDataModal = () => {
        const { showUploadDataModal, importType } = this.state;
        if (!showUploadDataModal) return null;
        const {
            match: {
                params: { section }
            }
        } = this.props;
        const clientDetails = section === "assetinfo" ? this.props.basicDetails : this.props.basicDetails?.client;
        return (
            <Portal
                body={
                    <BulkUploadForm
                        importType={importType}
                        clientDetails={clientDetails}
                        onCancel={() => this.setState({ showUploadDataModal: false })}
                        onSuccess={this.refreshDataList}
                    />
                }
                onCancel={() => this.setState({ showUploadDataModal: false })}
            />
        );
    };

    updateLastSortFilter = async (searchKey, val) => {
        if (this.state.params.order && this.state.params?.order[searchKey]) {
            await this.setState({
                params: {
                    ...this.state.params,
                    order: {
                        [searchKey]: this.state.params.order[searchKey] === "asc" ? "desc" : "asc"
                    }
                }
            });
        } else {
            await this.setState({
                params: {
                    ...this.state.params,
                    order: { [searchKey]: "desc" }
                }
            });
        }
        this.updateEntityParams();
        await this.refreshDataList();
    };

    filterByGuid = async () => {
        const { guid_assigned } = this.state.params;
        await this.setState({
            params: {
                ...this.state.params,
                offset: 0,
                guid_assigned: guid_assigned === "true" ? "false" : guid_assigned === "false" ? null : "true"
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            }
        });
        this.updateEntityParams();
        await this.refreshDataList();
    };

    filterByImages = async () => {
        const { has_image } = this.state.params;
        await this.setState({
            params: {
                ...this.state.params,
                offset: 0,
                has_image: has_image === "true" ? "false" : has_image === "false" ? null : "true"
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            }
        });
        this.updateEntityParams();
        await this.refreshDataList();
    };

    toggleFiltersPopup = () => {
        this.setState({ showFiltersPopup: !this.state.showFiltersPopup });
    };

    getCurrentFilters = () => {
        let { limit, offset, has_image, verified_survey, ...currentFilters } = { ...this.state.params };
        if (this.props.isAssignView) {
            currentFilters.client_id = this.props.clientId;
        }
        const { section, id } = this.props.match.params;
        switch (section) {
            case "assetinfo":
                currentFilters.client_id = id;
                break;
            case "regioninfo":
                currentFilters.region_id = id;
                break;
            case "siteinfo":
                currentFilters.site_id = id;
                break;
            case "buildinginfo":
                currentFilters.building_id = id;
                break;

            default:
                break;
        }
        if (this.props.match.params.subTab === "assigned-assets" && this.props?.assignedAssets)
            currentFilters = { ...currentFilters, asset_survey_project_id: id };
        return currentFilters;
    };

    renderFiltersPopup = () => {
        const { showFiltersPopup } = this.state;
        if (!showFiltersPopup) return null;
        return (
            <Portal
                body={
                    <MyFilters
                        currentFilters={this.getCurrentFilters()}
                        onCancel={() => this.toggleFiltersPopup()}
                        submitMasterFilter={this.submitMasterFilter}
                        prepareDropdownApiParams={this.getMasterFilterDropdownParams}
                        tableConfig={this.state.tableData.config}
                        assetViewFieldConfig={this.state.assetViewFieldConfig}
                        asset_custom_field={this.props.assetReducer?.assetDynamicFields?.asset_custom_field}
                        isMobilecomAssetView={this.props?.isMobilecomAssetView ?? ""}
                    />
                }
                onCancel={() => this.toggleFiltersPopup()}
            />
        );
    };

    submitMasterFilter = filterData => {
        const { filters, ...rest } = filterData || {};
        let image_assigned_filter = null;
        if (rest?.has_image?.length) {
            image_assigned_filter = rest.has_image[0];
        }
        let verified_survey_filter = null;

        if (rest?.verified_survey?.length) {
            verified_survey_filter = rest.verified_survey[0];
        }
        this.setState(
            {
                params: {
                    ...this.state.params,
                    filters: Object.keys(filters)?.length ? filters : null,
                    list: rest,
                    has_image: image_assigned_filter,
                    verified_survey: verified_survey_filter
                }
            },
            async () => this.refreshDataList()
        );
    };

    renderAppliedFilters = () => {
        const { showAppliedFilters, params } = this.state;
        if (!showAppliedFilters) return null;
        return (
            <Portal
                body={
                    <AppliedFilters
                        myFilters={{}}
                        filterValues={params}
                        assetDashboardFilterTags={this.getAssetDashboardAppliedFilterTags()}
                        openFiltersPopup={() => this.setState({ showFiltersPopup: true })}
                        showFiltersIcon={!this.state.showFiltersPopup}
                        onCancel={() => this.setState({ showAppliedFilters: false })}
                        source="asset"
                        tableConfig={this.state.tableData.config}
                    />
                }
                onCancel={() => this.setState({ showAppliedFilters: false })}
            />
        );
    };

    toggleAppliedFiltersPopup = () => {
        this.setState({ showAppliedFilters: !this.state.showAppliedFilters });
    };

    handleSelectMultiAsset = async ({ id, locked }, isChecked) => {
        this.setState({ isLoading: true });
        await new Promise(resolve => setTimeout(resolve, 1));

        const {
            selectedAssetsId,
            paginationParams: { currentPage, perPage },
            dataList
        } = this.state;

        const pageBase = currentPage * perPage;
        const itemIndex = dataList.findIndex(elem => elem.id === id);
        const index = pageBase + (itemIndex + 1);

        await this.setState({
            selectedAssetsId: isChecked ? [...selectedAssetsId, { id, index, locked }] : selectedAssetsId.filter(t => t.id !== id),
            isLoading: false
        });

        this.updateEntityParams();
    };

    handleSelectAllAssets = async isChecked => {
        this.setState({ isLoading: true });
        await new Promise(resolve => setTimeout(resolve, 1));

        const {
            dataList,
            paginationParams: { perPage, currentPage },
            selectedAssetsId: existingSelected = []
        } = this.state;

        const pageBase = currentPage * perPage;
        let tempSelected = [...existingSelected];

        if (isChecked) {
            const toAdd = dataList.map((item, idx) => ({
                id: item.id,
                locked: item?.locked,
                index: pageBase + (idx + 1)
            }));

            if (this.props.isSurveyView) {
                tempSelected = _.uniqBy([...tempSelected.filter(sel => !dataList.some(d => d.id === sel.id)), ...toAdd], "id");
            } else {
                tempSelected = toAdd;
            }
        } else {
            if (this.props.isSurveyView) {
                tempSelected = tempSelected.filter(sel => !dataList.some(d => d.id === sel.id));
            } else {
                tempSelected = [];
            }
        }

        await this.setState({
            selectedAssetsId: tempSelected,
            isLoading: false
        });
        this.updateEntityParams();
    };

    clearSelection = async () => {
        const hadAssetIdParam = this.state.params?.asset_ids ? true : false;
        await this.setState({ selectedAssetsId: [], params: { ...this.state.params, asset_ids: null } });
        this.updateEntityParams();
        if (hadAssetIdParam) await this.refreshDataList();
    };

    showSelectedAssets = async () => {
        if (this.state.params.asset_ids?.length) {
            await this.setState({
                params: {
                    ...this.state.params,
                    offset: 0,
                    asset_ids: null
                },
                paginationParams: {
                    ...this.state.paginationParams,
                    currentPage: 0
                }
            });
        } else {
            await this.setState({
                params: {
                    ...this.state.params,
                    offset: 0,
                    asset_ids: this.state.selectedAssetsId.map(elem => elem.id)
                },
                paginationParams: {
                    ...this.state.paginationParams,
                    currentPage: 0
                }
            });
        }
        this.updateEntityParams();
        await this.refreshDataList();
    };

    toggleMultiSelectEditForm = async () => {
        const hasLockRecom = this.state.selectedAssetsId.some(elem => elem.locked);
        if (hasLockRecom) {
            this.setState(
                {
                    alertMessage: "Locked assets cannot be edited!"
                },
                () => this.showAlert()
            );
        } else {
            this.setState({ showMultiSelectEditForm: !this.state.showMultiSelectEditForm });
        }
    };

    handleMultiAssetUpdate = async values => {
        await this.props.updateMultiAssets(values);
        if (this.props.assetReducer.updateMultipleAssetsResponse && this.props.assetReducer.updateMultipleAssetsResponse.error) {
            await this.setState({
                alertMessage: this.props.assetReducer.updateMultipleAssetsResponse.error
            });
            this.showAlert();
        } else {
            this.toggleMultiSelectEditForm();
            await this.setState({
                selectedAssetsId: [],
                params: {
                    ...this.state.params,
                    offset: 0
                },
                paginationParams: {
                    ...this.state.paginationParams,
                    currentPage: 0
                }
            });
            await this.refreshDataList();
            await this.setState({
                alertMessage: this.props.assetReducer.updateMultipleAssetsResponse?.message
            });
            this.showAlert();
        }
    };

    renderMultiSelectEditForm = () => {
        const { showMultiSelectEditForm } = this.state;
        if (!showMultiSelectEditForm) return null;
        const { basicDetails, isMobilecomAssetView = false } = this.props;
        const clientId = basicDetails?.client?.id;
        return (
            <Portal
                body={
                    <MultiSelectEditForm
                        onCancel={this.toggleMultiSelectEditForm}
                        selectedAssetsIds={this.state.selectedAssetsId}
                        clientId={clientId}
                        handleMultiAssetUpdate={this.handleMultiAssetUpdate}
                        assetViewFieldConfig={this.state.assetViewFieldConfig}
                        isMobilecomAssetView={isMobilecomAssetView ?? false}
                    />
                }
                onCancel={this.toggleMultiSelectEditForm}
            />
        );
    };

    assignImagesToAsset = async imageData => {
        await this.props.assignImagesToSection(imageData, this.props.match.params.id, "assets");
        return this.props.imageReducer.assignImageResponse;
    };

    getAssetListTableConfigParams = () => {
        const { subParams, clientIdToPersist } = this.getScopedAssetParams(this.state.params || {});
        return {
            client_id: clientIdToPersist ?? subParams.client_id ?? null
        };
    };

    setTableDataConfigBasedOnProject = async () => {
        const { assetReducer } = this.props;
        const { client_id } = this.getAssetListTableConfigParams();
        const dynamicBands = assetReducer?.assetDynamicFields?.asset_custom_field || {};
        // refetch: no other path on this screen refreshes the cached client field configuration
        const [userTableConfig, assetViewConfig] = await Promise.all([
            getTableConfig({
                user_id: localStorage.getItem("userId"),
                client_id,
                table_type: entities.ASSET_MANAGEMENT
            }),
            client_id
                ? resolveAssetViewFieldConfig({
                      clientId: client_id,
                      dynamicBands,
                      role: localStorage.getItem("role") || "",
                      layoutContext: "view",
                      refetch: true
                  })
                : null
        ]);
        const tableSettings = userTableConfig?.data?.table_settings || null;
        const { config: computedConfig, keys: computedKeys } = computeTableConfig({
            defaultConfig: assetTableData.config,
            defaultKeys: assetTableData.keys,
            tableSettings,
            recommendationCustomFields: dynamicBands
        });
        const { keys: nextKeys, config: nextConfig } = applyAssetViewVisibilityToTableConfig(
            { keys: computedKeys, config: computedConfig },
            assetViewConfig?.fieldConfig
        );
        await this.setState({
            tableData: {
                ...this.state.tableData,
                keys: nextKeys,
                config: nextConfig
            },
            assetViewFieldConfig: assetViewConfig?.fieldConfig || null,
            tableConfigChanged: !!tableSettings
        });
        await this.updateEntityParams();
    };

    saveUserTableConfig = async (config, isReset) => {
        const entity = entities.ASSET_MANAGEMENT;
        const { client_id } = this.getAssetListTableConfigParams();
        await saveTableConfig({
            user_id: localStorage.getItem("userId"),
            client_id,
            table_type: entity,
            table_settings: isReset
                ? null
                : stripAdminHiddenColumnsFromSave({ keys: this.state.tableData.keys, config: config || this.state.tableData.config })
        });
        this.setState({ tableConfigChanged: isReset ? false : true });
    };

    resetAllTableConfig = async () => {
        this.setState({ isTableResetting: true, isLoading: true });
        // if (!this.props?.isSmartChartView) {
        await this.saveUserTableConfig(null, true);
        // }
        await this.setTableDataConfigBasedOnProject();
        this.setState({ isTableResetting: false, isLoading: false });
    };
    handleGoToColumn = async gotoKey => {
        if (gotoKey) {
            this.setState({
                setSearchField: gotoKey,
                setHighlightSearchField: gotoKey
            });
        }
    };
    // ---------------------------------------------------------------------------------------------------
    // Otto (table_view). The controller is the uniform interface Otto's executor drives; it is built ONCE and
    // cached because Otto's send callback depends on its identity, while every getter reads LIVE state.
    // ---------------------------------------------------------------------------------------------------

    // The grid AS OTTO SEES IT: admin-hidden columns removed entirely, not merely reported as hidden. Same
    // principle as the dashboard's role-hidden filter fields (FTO-70) — a restricted column must not be
    // nameable, or Otto offers to "show the X column", the merge below correctly refuses, and Otto reports a
    // success that didn't happen. Stripping at the source means it is never offered in the first place.
    getOttoTableData = () => splitAdminHiddenColumns(this.state.tableData || {});

    getOttoTableController = () => {
        if (this._ottoTableController) return this._ottoTableController;
        this._ottoTableController = createTableController({
            getTableData: () => this.getOttoTableData(),
            getSort: () => (this.state.params && this.state.params.order) || null,
            getPagination: () => this.state.paginationParams || null,
            sortColumn: key => this.updateTableSortFilters(key),
            // handleColumnVisibilityApply, NOT the raw handleHideColumn: it re-merges the admin-hidden
            // columns, so an Otto-produced config can never un-hide a restricted field. Defence in depth
            // behind getOttoTableData above.
            hideColumn: tableConfig => this.handleColumnVisibilityApply(tableConfig),
            pinColumn: key => this.handleColumnPin(key),
            unpinAll: () => this.unPinAllColumn(),
            setPageSize: n => this.handlePerPageChange({ target: { value: String(n) } }),
            resetSort: () => this.resetSort(),
            resetLocalFilters: () => this.resetAllFilters(),
            resetTableConfig: () => this.resetAllTableConfig(),
            // Mirrors AssetExportPopup.jsx, which has exactly two cards and builds Excel only (`is_excel:true`
            // in exportTableXl) — so `formats` stays ["excel"] and Otto never promises Word or PDF here.
            //   simple   -> the popup's "Simple Export" card (exportType "regular").
            //   variants -> its "Asset Grouping" card (exportType "grouping"), individually runnable.
            //   advanced -> the popup itself, where the grouping axis + saved settings are chosen.
            // A FUNCTION because the controller is cached while the export permission is read live.
            exportCapability: () => ({
                enabled: this.hasOttoExportPermission(),
                formats: ["excel"],
                advanced: true,
                variants: [
                    {
                        key: "grouping",
                        label: "Asset Grouping",
                        formats: ["excel"],
                        synonyms: ["grouping", "grouped", "asset grouping", "grouping export", "grouped export"]
                    }
                ]
            }),
            exportTable: (format, opts) => this.ottoExportTable(format, opts),
            exportVariant: (key, opts) => this.ottoExportVariant(key, opts),
            openAdvancedExport: () => this.openOttoAdvancedExport(),
            // ---- VIEW-SHAPING deps. Each goes through the page's OWN handler — the same call the toolbar
            // button makes — so an Otto-driven change is indistinguishable from a hand-driven one.
            // Deliberately ABSENT: Saved Filters / Saved Views / Refresh (this page never passes those props
            // to TableTopIcons, so the buttons do not exist here) and the GUID/Image toggles (reachable only
            // through the More Filters button, which is off — `hasAdditionalFilters={false}` in DataMain.jsx).
            setGlobalSearch: text => this.handleGlobalSearch(text),
            // The grid's two "recently touched" axes. Reads the searchKey/label straight off the LIVE table
            // config — the same lookup the toolbar's "Sort by Newly Created"/"Sort by Newly Edited" buttons
            // make (TableTopIcons.jsx's setSortOrderParamsByArrow, called with
            // tableData.config["created_at"|"updated_at"].searchKey and a display label) — never a
            // hardcoded "assets.created_at"/"assets.updated_at", so this stays correct if the column config
            // ever changes. Also mirrors that same call site's own guard (it only forwards to
            // updateLastSortFilter when tableData.data.length): sorting an empty grid is a no-op for the
            // button, so an Otto-driven request behaves identically instead of quietly recording an order
            // there is currently nothing visible to apply it to.
            sortRecent: axis => {
                const column = this.state.tableData?.config?.[axis === "edited" ? "updated_at" : "created_at"];
                if (!column?.searchKey || !this.state.tableData?.data?.length) return;
                this.updateLastSortFilter(column.searchKey, column.label);
            },
            gotoColumn: key => this.handleGoToColumn(key),
            // resetAll, NOT resetAllFilters (that's resetLocalFilters above) — this is the toolbar's
            // "Reset all Filters & Sort".
            resetAll: () => this.resetAll(),
            openFilters: () => this.toggleFiltersPopup(),
            openAppliedFilters: () => this.toggleAppliedFiltersPopup()
        });
        return this._ottoTableController;
    };

    // The SAME permission that gates this page's own export icon (`hasExport` in render).
    hasOttoExportPermission = () => checkPermission("forms", "assets", "export");

    // Otto's SIMPLE export = the popup's "Simple Export → Download File" (exportType "regular"), and the
    // variant = its "Asset Grouping" card. Both go through exportTableXl, the identical path the popup's own
    // buttons take, so an Otto-run export is indistinguishable from a hand-run one — and it returns the
    // outcome ({ status: "downloaded" | "queued" | "error" }) so Otto reports what actually happened rather
    // than assuming a download.
    ottoExportTable = () => this.exportTableXl({ exportType: "regular", grouping: [] });

    ottoExportVariant = (key, opts = {}) => {
        if (key === "grouping") return this.exportTableXl({ exportType: "grouping", grouping: [] });
        // Unknown key (a stale declaration) — open the chooser rather than dropping the request silently.
        this.openOttoAdvancedExport();
        return { status: "opened" };
    };

    openOttoAdvancedExport = () => this.setState({ showExportModal: true });

    // Mount Otto only on the STANDALONE asset list — never the embedded reuses of this container (smart
    // chart, assign, project/mobilecom asset views), which have their own chrome and no room for a launcher.
    // Otto's own access config gates final visibility; this just scopes it to the right surface.
    renderOttoAssistant = () => {
        if (!canUseOtto()) return null; // central policy in filterAssistant/core/ottoAccess
        const { isSmartChartView, isAssignView, isAssignAssetView, isProjectAssetView, isMobilecomAssetView } = this.props;
        if (isSmartChartView || isAssignView || isAssignAssetView || isProjectAssetView || isMobilecomAssetView) return null;
        // The legacy standalone /assets route (App.js) has no inbound links and no parent record. Otto's
        // two registered page keys are both wrong for it ("assets" = the asset hub's own tab; "scopedAssets"
        // = embedded in a parent record) — so it doesn't mount here rather than mislabel the surface.
        if (isLegacyStandaloneAssetsRoute(this.props.match.path)) return null;
        const { match: { params: { section = "", id = "" } = {} } = {} } = this.props;
        return (
            <AssetsOtto
                section={section}
                clientId={section === "assetinfo" ? id : undefined}
                tableController={this.getOttoTableController()}
                assetViewFieldConfig={this.state.assetViewFieldConfig}
                getCurrentFilters={this.getCurrentFilters}
                prepareDropdownApiParams={this.getMasterFilterDropdownParams}
                onSetLocalFilters={this.submitMasterFilter}
            />
        );
    };

    renderExportPopup = () => {
        const { showExportModal, tableData } = this.state;
        if (!showExportModal) return null;

        const {
            location: { search = "" },
            match: {
                params: { section = "", id = "" }
            }
        } = this.props;
        const query = qs.parse(search);
        const { client_id: scopedClientId } = this.getAssetListTableConfigParams();
        const clientId = scopedClientId || this.props.clientId || query?.client_id || query?.c_id;
        const projectId = this.props.basicDetails?.project?.id || query?.pid || (section === "projectinfo" ? id : "");

        return (
            <Portal
                body={
                    <AssetExportPopup
                        onCancel={() => {
                            this.setState({ showExportModal: false });
                        }}
                        handleSubmit={exportparams => {
                            this.exportTableXl({
                                ...exportparams,
                                ...(exportparams?.grouping ? { grouping: exportparams?.grouping } : { grouping: [] })
                            });
                        }}
                        loading={this.state?.tableLoading}
                        tableData={tableData}
                        clientIdForSmartChart={clientId}
                        projectIdForSmartChart={projectId}
                        groupingOptions={this.props.assetReducer.exportGroupingDropdownExport?.data ?? []}
                    />
                }
                onCancel={() => {
                    this.setState({ showExportModal: false });
                }}
            />
        );
    };

    getScopedAssetParams = baseParams => {
        const {
            match: {
                params: { id, section }
            },
            location: { search },
            isMobilecomAssetView = false
        } = this.props;
        const query = qs.parse(search);

        const { has_image, verified_survey: _omitVerified, ...restList } = baseParams?.list || {};
        let subParams = { ...(baseParams || {}), list: this.remapAssetDynamicFieldList(restList) };

        if (subParams.verified_survey === true || subParams.verified_survey === false) {
            subParams.verified_survey = subParams.verified_survey ? "yes" : "no";
        }

        if (this.props.surveyFilters) {
            const surveyFilters = this.props.surveyFilters;
            subParams = { ...subParams, region_id: surveyFilters?.region, site_id: surveyFilters?.site, building_id: surveyFilters?.building };
        }

        let clientIdToPersist;
        if (
            this.props.isAssignView ||
            this.props.isSmartChartView ||
            ((this.props.isProjectAssetView || this.props?.isMobilecomAssetView || query?.is_mr) && this.props.clientId)
        ) {
            clientIdToPersist = this.props.clientId ?? subParams.client_id;
            subParams.client_id = clientIdToPersist;
            const { smartChartFilters = {} } = this.props;
            if (smartChartFilters) subParams = { ...subParams, ...smartChartFilters };
        } else {
            switch (section) {
                case "assetinfo":
                    clientIdToPersist = this.props.clientId || query?.client_id || id || query?.c_id;
                    subParams.client_id = clientIdToPersist;
                    break;
                case "regioninfo":
                    subParams.region_id = id;
                    subParams.client_id = this.props.clientId;
                    break;
                case "siteinfo":
                    subParams.site_id = id;
                    subParams.client_id = this.props.clientId;
                    break;
                case "buildinginfo":
                    subParams.building_id = id;
                    subParams.client_id = this.props.clientId;
                    break;
                case "imageInfo":
                    subParams.image_id = id;
                    break;
                default:
                    clientIdToPersist = this.props.clientId || query?.client_id || id || query?.c_id;
                    subParams.client_id = clientIdToPersist;
            }
        }

        if (this.props.match.params.subTab === "assigned-assets") subParams = { ...subParams, asset_survey_project_id: id };
        if (isMobilecomAssetView || query?.is_mr)
            subParams = { ...subParams, survey_recommendation_id: section === "assetInfo" ? (query?.s_id ?? id) : id };

        return { subParams, clientIdToPersist };
    };
    updateColumnWidthInConfig = (columnKey, style) => {
        const { keys, config } = this.state.tableData;

        const pinnedColumns = keys.filter(key => config[key]?.isVisible && config[key]?.pinned);
        const columnLeftValues = getPinnedColumnLeftPositions(pinnedColumns, this.pinnedColumnsRef);

        pinnedColumns.forEach(key => {
            config[key] = {
                ...config[key],
                style: {
                    ...config[key]?.style,
                    left: columnLeftValues[key] || "auto"
                }
            };
        });

        const updatedConfig = {
            ...config,
            [columnKey]: {
                ...config[columnKey],
                style: {
                    ...config[columnKey]?.style,
                    ...style
                }
            }
        };
        this.setState({
            tableData: {
                ...this.state.tableData,
                config: updatedConfig
            }
        });
        if (!this.props?.isSmartChartView) {
            this.saveUserTableConfig(updatedConfig);
        }
        this.updateEntityParams(updatedConfig);
    };

    handleColumnPin = async keyItem => {
        const { config, keys } = this.state.tableData;
        this.setState({
            isLoading: true
        });
        await new Promise(resolve => setTimeout(resolve, 1));
        const { left, ...remainingStyles } = config[keyItem]?.style || {};

        const updatedConfig = {
            ...config,
            [keyItem]: {
                ...config[keyItem],
                pinned: !config[keyItem]?.pinned,
                style: config[keyItem]?.pinned
                    ? remainingStyles
                    : {
                          ...remainingStyles,
                          left: config[keyItem]?.style?.left || "auto"
                      }
            }
        };

        const pinnedColumns = keys.filter(key => updatedConfig[key]?.pinned);
        const columnLeftValues = getPinnedColumnLeftPositions(pinnedColumns, this.pinnedColumnsRef);

        pinnedColumns.forEach(key => {
            updatedConfig[key] = {
                ...updatedConfig[key],
                style: {
                    ...config[key]?.style,
                    left: columnLeftValues[key] || "auto"
                }
            };
        });
        this.setState({
            tableData: {
                ...this.state.tableData,
                config: updatedConfig
            },
            isLoading: false
        });
        if (!this.props?.isSmartChartView) {
            this.saveUserTableConfig(updatedConfig);
        }
        this.updateEntityParams(updatedConfig);
    };
    unPinAllColumn = async () => {
        const { config, keys } = this.state.tableData;
        const updatedConfig = { ...config };
        keys.forEach(key => {
            updatedConfig[key] = {
                ...updatedConfig[key],
                pinned: false,
                style: {
                    ...config[key]?.style,
                    left: "auto"
                }
            };
        });
        await this.setState({
            tableData: {
                ...this.state.tableData,
                config: updatedConfig
            }
        });
    };

    render() {
        const {
            showViewModal,
            showWildCardFilter,
            paginationParams,
            tableData,
            selectedRowId,
            infoTabsData,
            logData,
            historyPaginationParams,
            historyParams,
            selectedData,
            isHistory,
            imageResponse,
            summaryRowData,
            locationState,
            exportLoader,
            selectedAssetsId,
            tableDataExportFilters
        } = this.state;

        const {
            match: {
                params: { section }
            },
            isAssignView,
            isImageView,
            isSmartChartView,
            isAssignAssetView,
            viewOnly = false,
            isSurveyView,
            handleSurveyAssign,
            assignedAssets,
            initialSelectedAssets = [],
            isMobilecomAssetView = false
        } = this.props;
        // const tableWrapperClass = lineEditingEnabled ? `fullscreen-table ${isMobilecomAssetView ? "full-screen-ast" : ""}` : "normal-table-container";

        return (
            <LoadingOverlay active={this.state.isLoading} spinner={<Loader />} fadeSpeed={10}>
                {!isAssignView && !isSmartChartView && (section === "add" || section === "edit") ? (
                    <Form
                        key={(this.props.match.params.id || "add") + this.props.location.search}
                        selectedData={selectedData}
                        refreshDataList={this.refreshDataList}
                        handleAddData={this.handleAddData}
                        handleUpdateData={this.handleUpdateData}
                        getAssetById={this.getDataById}
                        cancelForm={this.cancelForm}
                    />
                ) : section === "assetInfo" ? (
                    <InfoPage
                        keys={tableData.keys}
                        config={tableData.config}
                        infoTabsData={infoTabsData}
                        getDataById={this.getDataById}
                        showInfoPage={this.showInfoPage}
                        showEditPage={this.showEditPage}
                        updateData={this.handleUpdateData}
                        handleDeleteItem={this.handleDeleteData}
                        getAllDataLogs={this.getLogData}
                        handlePerPageChangeHistory={this.handlePerPageChangeHistory}
                        handlePageClickHistory={this.handlePageClickHistory}
                        handleGlobalSearchHistory={this.handleGlobalSearchHistory}
                        globalSearchKeyHistory={this.state.historyParams && this.state.historyParams.search ? this.state.historyParams.search : ""}
                        logData={logData}
                        handleDeleteLog={this.handleDeleteLog}
                        restoreLog={this.restoreLogOnConfirm}
                        historyPaginationParams={historyPaginationParams}
                        historyParams={historyParams}
                        updateLogSortFilters={this.updateLogSortFilters}
                        selectedData={selectedData}
                        hasExport={checkPermission("forms", "assets", "export")}
                        hasEdit={checkPermission("forms", "assets", "edit") && !isAssignAssetView}
                        hasDelete={checkPermission("forms", "assets", "delete") && !isAssignAssetView}
                        hasLogView={checkPermission("logs", "assets", "view")}
                        hasLogDelete={checkPermission("logs", "assets", "delete")}
                        hasLogRestore={checkPermission("logs", "assets", "restore")}
                        hasInfoPage={!isSmartChartView && checkPermission("forms", "assets", "view")}
                        // hasCreate={checkPermission("forms", "assets", "create")}
                        cancelInfoPage={this.cancelInfoPage}
                        cancelForm={this.cancelForm}
                        isHistory={isHistory}
                        toggleHistory={this.toggleHistory}
                        entity={"assets"}
                        getAllImageList={this.getAllImageList}
                        uploadImages={this.uploadImages}
                        imageResponse={imageResponse}
                        updateAssetImages={this.updateAssetImages}
                        deleteImages={this.deleteImages}
                        tableData={this.props.assetReducer.getDataResponse?.assets}
                        onePagerExport={this.onePagerExport}
                        exportLoader={exportLoader}
                        dynamicBands={this.props.assetReducer.assetDynamicFields?.asset_custom_field}
                        assignImagesToAsset={this.assignImagesToAsset}
                        showRestoreModal={this.showRestoreModal}
                    />
                ) : (
                    <DataMain
                        showWildCardFilter={showWildCardFilter}
                        paginationParams={paginationParams}
                        tableData={tableData}
                        handleGlobalSearch={this.handleGlobalSearch}
                        globalSearchKey={this.state.params.search}
                        updateSelectedRow={this.updateSelectedRow}
                        selectedRowId={selectedRowId}
                        toggleWildCardFilter={this.toggleWildCardFilter}
                        showEditPage={this.showEditPage}
                        handlePerPageChange={this.handlePerPageChange}
                        handlePageClick={this.handlePageClick}
                        showAddForm={this.showAddForm}
                        showInfoPage={this.showInfoPage}
                        isColunmVisibleChanged={this.isColunmVisibleChanged}
                        updateWildCardFilter={this.updateWildCardFilter}
                        wildCardFilter={this.state.params.filters}
                        handleHideColumn={this.handleHideColumn}
                        getListForCommonFilterFloor={this.getListForCommonFilter}
                        updateCommonFilter={this.updateCommonFilter}
                        commonFilter={this.state.params.list}
                        resetAllFilters={this.resetAllFilters}
                        resetAll={this.resetAll}
                        updateTableSortFilters={this.updateTableSortFilters}
                        resetSort={this.resetSort}
                        tableParams={this.state.params}
                        exportTableXl={() => this.setState({ showExportModal: true })}
                        exportCustomExcel={this.exportCustomExcel}
                        tableLoading={this.state.tableLoading}
                        customExcelExportLoading={this.state.customExcelExportLoading}
                        showViewModal={this.showViewModal}
                        summaryRowData={summaryRowData}
                        handleDelete={this.handleDeleteData}
                        hasExport={checkPermission("forms", "assets", "export")}
                        showAddButton={
                            !isAssignAssetView &&
                            !isAssignView &&
                            !isImageView &&
                            !isSmartChartView &&
                            checkPermission("forms", "assets", "create") &&
                            !isMobilecomAssetView
                        }
                        hasEdit={checkPermission("forms", "assets", "edit") && !isAssignAssetView && !isSurveyView}
                        hasDelete={checkPermission("forms", "assets", "delete") && !isAssignAssetView && !isSurveyView}
                        hasInfoPage={!isSmartChartView && !isAssignView && checkPermission("forms", "assets", "view")}
                        hasActionColumn={!(isAssignView || (isSmartChartView && !isSurveyView))}
                        isAssignAsset={isAssignView}
                        entity={"assets"}
                        handleSelectAsset={this.handleSelectAsset}
                        selectedAsset={this.props.assetReducer.selectedAsset}
                        tableRef={this.tableRef}
                        filterByRecommendationAssigned={this.filterByRecommendationAssigned}
                        isAssetDashboardFiltered={this.isAssetDashboardFiltered}
                        hasViewIcon={!isAssignView && checkPermission("forms", "assets", "view") && !isSurveyView}
                        showUploadDataModal={this.showUploadDataModal}
                        updateLastSortFilter={this.updateLastSortFilter}
                        filterByGuid={this.filterByGuid}
                        filterByImages={this.filterByImages}
                        openFiltersPopup={this.toggleFiltersPopup}
                        toggleAppliedFiltersPopup={this.toggleAppliedFiltersPopup}
                        isSmartChartView={this.props.isSmartChartView}
                        handleSelectRecom={this.handleSelectMultiAsset}
                        selectedRecomIds={selectedAssetsId.map(e => e.id)}
                        handleSelectAllRecom={this.handleSelectAllAssets}
                        clearSelection={this.clearSelection}
                        showSelectedAssets={this.showSelectedAssets}
                        selectWholeAssets={this.selectWholeAssets}
                        everyItemCheckedPerPage={tableData?.data?.every(item => selectedAssetsId.find(e => e.id === item.id))}
                        hasMultiAction={!isAssignView && !isAssignAssetView}
                        isAssignView={isAssignView || isAssignAssetView}
                        handleEditMultiSelectedData={this.toggleMultiSelectEditForm}
                        recommendationAssignedCount={this.props.assetReducer.recommendationAssignedCount}
                        hasSurveyAssign={isSurveyView}
                        assignedAssets={assignedAssets}
                        handleSurveyAssign={handleSurveyAssign}
                        initialSelectedAssets={initialSelectedAssets}
                        viewOnly={viewOnly}
                        showRestoreModal={this.showRestoreModal}
                        resetAllTableConfig={this.resetAllTableConfig}
                        isTableResetting={this.state.isTableResetting}
                        tableDataExportFilters={tableDataExportFilters}
                        searchField={this.state?.setSearchField}
                        setSearchField={() => {
                            this.setState({ setSearchField: null });
                        }}
                        setHighlightSearchField={this.state?.setHighlightSearchField}
                        pinnedColumnsRef={this.pinnedColumnsRef}
                        hasGoToFunctionality={true}
                        updateColumnWidthInConfig={this.updateColumnWidthInConfig}
                        handleColumnPin={this.handleColumnPin}
                        unPinAllColumn={this.unPinAllColumn}
                        hasPin={true}
                        assetDashboardFilterParams={this.getAssetDashboardTableFilterParams()}
                        assetChartNavigationFilterCount={this.getAssetChartNavigationFilterCount()}
                    />
                )}
                {showViewModal ? (
                    <Portal
                        body={
                            <DynamicColumnModal
                                tableData={splitAdminHiddenColumns(tableData)}
                                handleHideColumn={this.handleColumnVisibilityApply}
                                onCancel={() => {
                                    this.setState({ showViewModal: false });
                                    this.props?.isDraggable && this.props?.isDraggable(false);
                                }}
                                isDraggable={this.props?.isDraggable}
                                handleGoToColumn={this.handleGoToColumn}
                            />
                        }
                        onCancel={() => {
                            this.setState({ showViewModal: false });
                            this.props?.isDraggable && this.props?.isDraggable(false);
                        }}
                    />
                ) : null}
                {this.renderConfirmationModalLog()}
                {this.renderConfirmationModal()}
                {this.renderHardDeleteConfirmationModal()}
                {this.renderRestoreConfirmationModal()}
                {this.renderAssetOnePagerExportModal()}
                {this.renderUploadDataModal()}
                {this.renderFiltersPopup()}
                {this.renderAppliedFilters()}
                {this.renderAssetExportSettings()}
                {this.renderMultiSelectEditForm()}
                {this.renderExportPopup()}
                {this.renderOttoAssistant()}
            </LoadingOverlay>
        );
    }
}
const mapStateToProps = state => {
    const { assetReducer, imageReducer, assetDashboardReducer } = state;
    return { assetReducer, imageReducer, assetDashboardReducer };
};

export default withRouter(
    connect(mapStateToProps, {
        ...actions,
        assignImagesToSection: ImageActions.assignImagesToSection
    })(Assets)
);
